exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_syncPanel_BY_eZIxCUdDd6eSbIR7F6 {\n  padding: 0 40px;\n}", ""]);

// Exports
exports.locals = {
	"IA_syncPanel": "IA_syncPanel_BY_eZIxCUdDd6eSbIR7F6"
};